export default {
  // Buttons
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  confirm: 'Confirm',
  cancel: 'Cancel',

  // Table column headers
  menuName: 'Menu Name',
  icon: 'Icon',
  order: 'Order',
  routeName: 'Route Name',
  componentPath: 'Component Path',
  routePath: 'Route Path',
  status: 'Status',
  createTime: 'Create Time',
  action: 'Action',

  // Form labels
  parentMenu: 'Parent Menu',
  menuType: 'Menu Type',
  menuIcon: 'Menu Icon',
  menuNameLabel: 'Menu Name',
  routeAddress: 'Route Address',
  componentName: 'Component Name',
  componentPathLabel: 'Component Path',
  displayOrder: 'Display Order',
  isExternalLink: 'Is External Link',
  permissionChar: 'Permission Character',
  usageType: 'Usage Type',
  isVisible: 'Is Visible',

  // Placeholders
  selectParentMenu: 'Please select parent menu',
  fillOrder: 'Fill in the order',

  // Status
  normal: 'Normal',

  // Modal titles
  addMenu: 'Add Menu',
  editMenu: 'Edit Menu',

  // Confirmation dialog
  deleteConfirm: 'Are you sure to delete',

  // Success messages
  deleteSuccess: 'Deleted successfully',
  editSuccess: 'Modified successfully',
  addSuccess: 'Added successfully',

  // Validation messages
  parentMenuRequired: 'Parent menu cannot be empty',
  menuOrderRequired: 'Menu order cannot be empty',
  routeAddressRequired: 'Route address cannot be empty',
  componentAddressRequired: 'Component address cannot be empty',
  menuNameRequired: 'Please enter menu name',

  // Tree node
  mainCategory: 'Main Category',

  // Common options
  yes: 'Yes',
  no: 'No',
}
